function ViolationTile(props) {
  return(
    <div className="pt-4 cursor-pointer">
      <div className="bg-dark shadow-md border rounded-lg text-dark p-4 w-full">
        <div className="flex flex-row">
          <div className="font-gilroy text-white font-bold">{props.violater}</div>
          <div className="font-gilroy flex-grow"></div>
          <div className="font-gilroy text-white font-bold">{props.time}</div>
        </div>
        <div className="font-gilroy text-white">{props.violation}</div>
      </div>
    </div>
  );
}

export default ViolationTile;
